import { useAppSelector } from '../../store/hooks';

export function useIsEnergieScwabenTenant() {
  const { demandArea } = useAppSelector(({ endUser }) => endUser);

  const isEnergieSchwaben =
    demandArea?.project?.domain === 'energie-schwaben-meinzuhause.de' ||
    demandArea?.tenant.name === 'EnergieSchwaben';

  return { isEnergieSchwaben };
}
